<template>
  <div class="app-content-template-default">
    <div class="app-content-template-default-inner">

      <b-container>
        <b-row>
          <b-col>

            <slot/>

          </b-col>
        </b-row>
      </b-container>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AppContentTemplateDefault',
}
</script>

<style scoped lang="scss">
  .app-content-default-template-footer {
    .container {
      padding: 0 !important;
    }
  }

  .app-content-template-default {
    width: 100%;

    .app-content-template-default-inner {
      width: 100%;
      padding: 32px 8px;
    }

    @media (min-width: $lgBreakpoint) {
      .app-content-template-default-inner {
        max-width: $appWidth;
        margin: auto;
        padding: 64px 8px;
      }
    }
  }
</style>
